import { ChangeDetectorRef, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { routes } from '../../constants/routes';
import { RouterLink } from '@angular/router';
import { NavbarComponent } from '../../components/layout/navbar/navbar.component';
import { FooterComponent } from '../../components/layout/footer/footer.component';
import { AccessibilityNavComponent } from '../../components/layout/accessability-nav/accessibility-nav.component';
import { pageSeoInfo } from '../../constants/page-seo-info';
import { SeoService } from '../../services/seo.service';
import { UtilityService } from '../../services/utility.service';
import { CachingService } from '../../services/caching.service';
import { distinctUntilChanged, skip } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
@Component({
  selector: 'app-sitemap',
  standalone: true,
  imports: [
    RouterLink,
    NavbarComponent,
    AccessibilityNavComponent,
    FooterComponent,
  ],
  templateUrl: './sitemap.component.html',
  styleUrl: './sitemap.component.scss',
})
export class SitemapComponent implements OnInit {
  readonly routes = routes;
  renderSitemapContent = true;
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private seoService: SeoService,
    protected utilityService: UtilityService,
    private cachingService: CachingService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    const { title, description, canonicalUrl } = pageSeoInfo['sitemap'];
    this.seoService.setPageTitle(title);
    this.seoService.setPageDescription(description);
    this.seoService.setCanonicalUrl(canonicalUrl);
    this.subscribeToLanguageChange();
  }
  private subscribeToLanguageChange(): void {
    this.cachingService.languageChange$
      .pipe(
        skip(1),
        distinctUntilChanged(),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        this.refreshAppContent();
      });
  }
  private refreshAppContent(): void {
    this.renderSitemapContent = false;
    this.cdr.detectChanges();
    setTimeout(() => {
      this.renderSitemapContent = true;
      this.cdr.detectChanges();
    });
  }
}
